module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('rss', {
    attrs: {
      "destination-url": "https://www.reddit.com/r/esist",
      "feed-url": "https://www.reddit.com/r/esist.rss",
      "title": "Reddit:r/esist",
      "hide": "description"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "https://www.reddit.com/r/worldnews",
      "feed-url": "https://www.reddit.com/r/worldnews.rss",
      "title": "Reddit:r/WorldNews",
      "hide": "description"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "https://www.reddit.com/r/politics",
      "feed-url": "https://www.reddit.com/r/politics.rss",
      "title": "Reddit:r/Politics"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "https://fivethirtyeight.com/politics",
      "feed-url": "https://fivethirtyeight.com/politics/feed/",
      "title": "538:Politics"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "http://thehill.com/homenews/administration",
      "feed-url": "http://thehill.com/taxonomy/term/1132/feed",
      "title": "TheHill:Administration"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "https://www.reddit.com/r/TrumpCriticizesTrump",
      "feed-url": "https://www.reddit.com/r/TrumpCriticizesTrump.rss",
      "title": "Reddit:r/TrumpCritcizesTrump",
      "includes": "",
      "hide": "description"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "https://www.reddit.com/r/liestrumptoldus",
      "feed-url": "https://www.reddit.com/r/liestrumptoldus.rss",
      "title": "Reddit:r/liestrumptoldus",
      "hide": "description"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "http://politico.com",
      "feed-url": "http://www.politico.com/rss/politicopicks.xml",
      "title": "Politico:Politics"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-445de2a0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 1079
// module chunks = 1